import {Directive, ElementRef, HostListener} from '@angular/core';
import {MyToastrService} from "../_services/toastr.service";

@Directive({
  selector: '[appPasswordCheck]'
})
export class PasswordCheckDirective {

  constructor(private el: ElementRef, private toast: MyToastrService) {
  }

  PASSWORD_REGX = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%_-])[0-9a-zA-Z!@#$%_-](?=.{5,13})');

  @HostListener('focusout')

  onFocusOut(): boolean {
    const current: string = this.el.nativeElement.value;
    if (current !== '') {
      if (current && !String(current).match(this.PASSWORD_REGX)) {
        this.toast.sToast('error', 'Incorrect Password! The password must be between 6 and 13 characters long, with no spaces in between. One capital, one lowercase, one numeric, and one special character (!@#$ % _-) are required.');
        this.el.nativeElement.focus();
        return false;
      } else {
        return true;
      }
    }
    return false;
  }
}
